import { FileMediaType } from '$types/fileMediaType';

const audioExtensions = ['mp3', 'wav', 'm4a', 'aac', 'ogg', 'oga', 'flac'];

export interface AudioFileLike {
  MediaType?: string | null;
  Key?: string | null;
  Url?: string | null;
}

/** Signed urls carry a query string, so the extension has to be read before it */
const hasAudioExtension = (value?: string | null) => {
  const extension = value?.split('?')[0]?.match(/\.([^./]+)$/)?.[1];
  return !!extension && audioExtensions.includes(extension.toLowerCase());
};

/**
 * `MediaType` is the source of truth; the extension is only a fallback for
 * payloads serialized before the discriminator existed.
 */
export default function isAudioFile(file?: AudioFileLike | null): boolean {
  if (!file) return false;
  if (file.MediaType) return file.MediaType === FileMediaType.AUDIO;
  return hasAudioExtension(file.Key) || hasAudioExtension(file.Url);
}
